function assertActionHandler(identifier, handler) {
  if (typeof identifier !== "string" || !identifier.trim() || typeof handler !== "function") {
    throw new TypeError("AppIntents.defineAction requires a non-empty identifier and a function");
  }
}
export {
  assertActionHandler
};
//# sourceMappingURL=validate.js.map
